<template>
  <div class="container-fluid">
    <div class="header py-5 col-12 text-center text-dark">
      <img src="@/assets/LOGO.gif" class="my-5" alt="" />
      <h1 class="text-center"><strong>上海安铠计算机软件有限公司</strong></h1>
      <h2 class="text-center"><i>Shanghai AKK Software CO.,LTD.</i></h2>
    </div>

    <div class="row py-5 text-center text-secondary">
      <h2 class="mx-auto">—— 关于我们 About Us ——</h2>
      <p class="col-12 mt-3 mx-auto" style="line-height: 300%">
        我们擅长于软件工程项目管理与软件系统开发，承接软件项目的外包/驻场研发、为客户提供应用系统的维护、数据处理等服务；<br />
        我们能承担修复和完善受损、被遗弃和半生不熟的程序的工作，尤其是由C#、Java、Kotlin、Typescript/Javascript等语言编写而成的应用程序；<br />
        我们也乐于使用和维护其它的开源的语言和系统，如Python/PHP等语言、Linux系统、以及许多的开源管理软件。
      </p>
    </div>

    <div class="row py-5 bg-light text-center text-secondary">
      <h2 class="mx-auto">—— 行业经验 Our Experience ——</h2>
      <p class="col-12 mt-3 mx-auto" style="line-height: 300%">
        我们在二十多年的软件设计、管理与开发工作中积累了丰富的行业经验。领域涉及 仓储物流、生产制造、客户关系、人力资源、教育教学、客服呼叫中心等等；<br/>
        应用软件涉及 WMS、MES、CRM、MRP、ERP、HR、CMS等；<br/>
        与智能设备和硬件的使用整合，如：条码、RFID、PDA、工业平板、PLC设备、以及各种工业传感器。
      </p>
    </div>

    <div class="footer text-secondary">
      <h2 class="text-center p-5">—— 联系我们 Contact Us ——</h2>
      <div class="pb-5 row justify-content-center">
        <div class="col-auto" style="line-height: 300%">
          <ul class="no-bullets">
            <li>投递合作意向: wing@kingsit.cn  <span class="ml-2">akin@kingsit.cn</span></li>
            <li>地址：上海市闵行区沪闵路7866弄莲花国际广场2号楼1006室</li>
          </ul>
        </div>
        <div class="col-auto ml-3">
          <img alt="akk logo" src="@/assets/akk001.png"/>
        </div>
      </div>

      <div class="pb-5 row">
        <div class="col-12 text-center">
          <a href="http://beian.miit.gov.cn" target="_blank" class="mr-3 text-decoration-none text-secondary">沪ICP备10030558号-5</a>
          <a target="_blank" class="text-decoration-none text-secondary" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010702001751"><span>沪公网安备
              31010702001751号</span></a>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.css";
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>
<style>
#con ul li {
  list-style-type: none;
  line-height: 300%;
  text-align: left;
}
</style>
